// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryTile_root__285LE","name":"CategoryTile_name__1C23b"};